<template>
    <main class="main-content" id="main-content">
        <div class="container">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("branches")}}
                </template>
            </page-header>
            <div class="section__body">
                <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Aa8abddb365e8787c9ce4824b501cf746a5db4034025a13378ffca7eeff22489f&amp;source=constructor" width="100%" height="544" frameborder="0"></iframe>
            </div>
          </section>
        </div>
    </main>
</template>
<script>
import PageHeader from "@/components/PageHeader";
export default {
components: {
    PageHeader
  },
}
</script>
<style scoped>
[class*="copyrights"]{
    display: none !important;
}
</style>